// src/components/AboutUs.js
import { useEffect, useState } from 'react';
import aboutUsContent from '../data/aboutUsContent';
// --- CORRECTED IMPORTS ---
import aboutusStyles from '../styles/aboutus.module.css'; // For language toggle buttons
// IMPORTANT: For global.css, import it directly without assigning to a variable.
// This makes its styles globally available to all components that import it (or a parent).
import '../styles/global.css'; // For imageFrame and other global styles
// If you have navbar.module.css, import it like this:
// import navbarStyles from '../styles/navbar.module.css';
// -------------------------

// --- IMPORT YOUR OPTIMIZED IMAGES HERE ---
import mdOfficePhoto from '../assets/md.jpg';
import officehead from '../assets/officehead.jpg';
import generalOfficePhoto from '../assets/reception2.jpg';
// ------------------------------------------

function AboutUs() {
  const [language, setLanguage] = useState(localStorage.getItem('preferredLang') || 'en');
  const [fade, setFade] = useState(true);

  useEffect(() => {
    localStorage.setItem('preferredLang', language);
    setFade(false);
    const timeout = setTimeout(() => setFade(true), 200);
    return () => clearTimeout(timeout);
  }, [language]);

  const currentContent = aboutUsContent[language];

  if (!currentContent) {
    return <section id="aboutus" className="py-5 bg-light text-center">Content not available.</section>;
  }

  return (
    <section
      id="aboutus"
      className="py-5"
      style={{ backgroundColor: 'var(--section-bg-light)', minHeight: '550px' }}
    >
      <div className="container" style={{ maxWidth: '900px' }}>
        <h2
          className="text-center mb-5 fw-bold"
          style={{
            color: 'var(--primary-brand-dark)',
            letterSpacing: '2px',
            fontSize: '2.8rem',
          }}
        >
          About Us
        </h2>

        {/* Language Toggle Buttons */}
        <div className="d-flex justify-content-center mb-5 gap-3">
          {['en', 'np', 'jp'].map((lang) => (
            <button
              key={lang}
              onClick={() => setLanguage(lang)}
              className={`${aboutusStyles.toggleBtn} ${
                language === lang ? aboutusStyles.active : ''
              }`}
              aria-label={`Switch to ${
                lang === 'en' ? 'English' : lang === 'np' ? 'Nepali' : 'Japanese'
              }`}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Content Box with Fade Animation */}
        <div
          className={`${aboutusStyles.contentBox} ${fade ? 'fade-in' : 'fade-out'}`}
        >
          {/* Tagline */}
          <p className={`text-center fs-5 mb-4 ${aboutusStyles.aboutUsTagline}`}>
            {currentContent.tagline}
          </p>

          {/* Paragraph 1 */}
          <p>
            {currentContent.paragraph1}
          </p>
          <div className="text-center my-5">
            <div
              // Corrected: Use "imageFrame" directly as a string class name for global CSS
              className="imageFrame"
              style={{ maxWidth: '740px' }}
            >
              <img
                src={officehead}
                alt="Office head of Shikitari Japanese Language Academy"
                className="img-fluid rounded"
                loading="lazy"
              />
            <h3 className="fw-bold mb-1" style={{ color: 'var(--primary-brand-dark)' }}>President</h3>
              <p className="mb-2"><strong>Narayan Prasad Sapkota</strong><br/> 理事長</p>
              <p>Narayan Prasad Sapkota, our President, ensures the steadfast dedication and operational excellence of our Nepal office, providing a strong base from which our specialized team guides your international education journey.</p>
            </div>
          </div>
          {/* Paragraph 2 */}
          <p>
            {currentContent.paragraph2}
          </p>

         {/* --- Leadership Section: MD Office Photo & Description (MOVED TO TOP) --- */} {/* Corrected comment syntax */}
          <div className="text-center my-5">
            <div
              // Corrected: Use "imageFrame" directly as a string class name for global CSS
              className="imageFrame"
              style={{ maxWidth: '600px' }}
            >
              <img
                src={mdOfficePhoto}
                alt="Managing Director in their office at Shikitari Japanese Language Academy"
                className="img-fluid rounded mb-3"
                loading="lazy"
              />
              {/* All MD description content is now inside this frame */}
              <h3 className="fw-bold mb-1" style={{ color: 'var(--primary-brand-dark)' }}>Meet Our Director/Principal</h3>
              <p className="mb-2"><strong>Nabaraj Gautam</strong><br/> MD/Principal（校長）</p>
              <p>Our director's vision and extensive experience of  providing unparalleled education and support for your journey to Japan.</p>
            </div>
          </div>


          {/* Paragraph 3 */}
          <p>
            {currentContent.paragraph3}
          </p>

          {/* List of features */}
          <ul style={{ listStyleType: 'square', marginLeft: '20px', marginBottom: '20px' }}>
            {currentContent.listItems.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>

          {/* --- Photo: General Office Interior/Staff Group Shot --- */} {/* Corrected comment syntax */}
          <div className="text-center my-5">
            <div
              // Corrected: Use "imageFrame" directly as a string class name for global CSS
              className="imageFrame"
              style={{ maxWidth: '740px' }}
            >
              <img
                src={generalOfficePhoto}
                alt="Interior of Shikitari Japanese Language Academy office showing a professional workspace and collaborative environment."
                className="img-fluid rounded"
                loading="lazy"
              />
              <p className="mb-2"><strong>Reception</strong><br/> </p>
              <p className="mt-3">A tech-savvy high school graduate with a keen learning mind, she ensures a warm welcome and efficient experience.</p>
            </div>
          </div>

          {/* Paragraph 4 */}
          <p>
            {currentContent.paragraph4}
          </p>

        </div>
      </div>
    </section>
  );
}

export default AboutUs;
